
import AboutHero from './components/AboutHero';
import MissionSection from './components/MissionSection';
import HistorySection from './components/HistorySection';
import ValuesSection from './components/ValuesSection';
import TeamSection from './components/TeamSection';
import FacilitiesSection from './components/FacilitiesSection';

export default function About() {
  return (
    <div>
      <AboutHero />
      <MissionSection />
      <HistorySection />
      <ValuesSection />
      <TeamSection />
      <FacilitiesSection />
    </div>
  );
}
